import React, { useEffect, useState } from "react";
import { apiGet } from "../../../API/Api_Url";
import { Calendar, DollarSign, MapPin, CreditCard } from "lucide-react";

function AllTransactions() {
  const [transactions, setTransactions] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const GetAllTransactions = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/labour/LabourGetAllTransactions`);
      if (response?.data) {
        setTransactions(response.data);
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setTransactions([]);
    } finally {
      setIsUploading(false);
    }
  };

  useEffect(() => {
    GetAllTransactions();
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div>
      {isUploading ? (
        <div className="flex items-center justify-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          <p className="ml-4 text-gray-600">Loading transactions...</p>
        </div>
      ) : transactions?.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-xl text-gray-500">No transactions found.</p>
        </div>
      ) : (
        <div className="grid gap-6 grid-cols-1">
          {transactions?.map((txn) => (
            <div
              key={txn?._id}
              className="bg-white rounded-2xl shadow-lg p-6 space-y-4"
            >
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold text-gray-800">
                  Transaction ID: {txn?._id}
                </h3>
                <span className="text-sm px-3 py-1 rounded-full bg-green-100 text-green-600">
                  ₹{txn?.Amount}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm text-gray-600">
                <div className="flex items-center">
                  <Calendar className="h-4 w-4 mr-2 text-gray-400" />
                  Duration: {txn?.WorkOrder?.DurationInDays} Days
                </div>
                <div className="flex items-center">
                  <DollarSign className="h-4 w-4 mr-2 text-gray-400" />
                  Daily Rate: ₹{txn?.WorkOrder?.DailyRate}
                </div>
                <div className="flex items-center col-span-2">
                  <MapPin className="h-4 w-4 mr-2 text-gray-400" />
                  {txn?.WorkOrder?.SiteLocation}
                </div>
              </div>
              <div className="text-sm text-gray-600">
                <div className="flex items-center">
                  <CreditCard className="h-4 w-4 mr-2 text-gray-400" />
                  Mode: {txn?.Mode}
                </div>
                {txn?.Note && (
                  <p className="mt-1">
                    <span className="font-medium">Note:</span> {txn.Note}
                  </p>
                )}
              </div>

              <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                <span className="flex items-center">
                  <Calendar className="h-4 w-4 mr-1" />
                  Paid At: {formatDate(txn?.PaidAt)}
                </span>
                <span className="text-gray-400">
                  Created: {formatDate(txn?.createdAt)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AllTransactions;
